<ng-container *transloco="let t; prefix: 'side-nav.footer.subscriptions'">
  @if (showUpgradeButton$ | async) {
    @if (customCheckoutPrimer$ | async; as customCheckoutPrimer) {
      <a
        class="ml-6 hidden! shrink-0 sm:inline-flex!"
        [href]="customCheckoutPrimer"
        (click)="onPrimerClick($event, customCheckoutPrimer)"
        mat-flat-button
        color="upgrade"
      >
        {{ t('upgrade') }}
      </a>
    } @else {
      @if (showFreeTrial$ | async) {
        <a class="ml-6 hidden! shrink-0 sm:inline-flex!" (click)="onClick()" mat-flat-button color="upgrade" routerLink="/billing/plans">
          {{ t('start-trial', { trialPeriodDays: (trialPeriodDays$ | async) }) }}
        </a>
      } @else {
        <a class="ml-6 hidden! shrink-0 sm:inline-flex!" (click)="onClick()" mat-flat-button color="upgrade" routerLink="/billing/plans">
          {{ t('upgrade') }}
        </a>
      }
    }
  }
</ng-container>
